import { render, staticRenderFns } from "./GlobalPatentDatabases.vue?vue&type=template&id=70b1f93e"
import script from "./GlobalPatentDatabases.vue?vue&type=script&lang=js"
export * from "./GlobalPatentDatabases.vue?vue&type=script&lang=js"
import style0 from "./GlobalPatentDatabases.vue?vue&type=style&index=0&id=70b1f93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports